<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-sm-12 col-xs-12 membercardcol">
          <div class="membercardfieldset margin20">
            <div class="membercardheader">
              <div class="row">
                <div class="col-md-9 col-sm-9 col-xs-9">
                  <span class="headertext" v-html="membershipdata.headerText"></span>
                  <br />
                  <span v-html="membershipdata.profgroupName"></span>
                  <br />
                  <span v-html="translation(15530) + ' ' + txtcreateDate"></span>
                  <br />
                </div>
                <div class="col-md-3 col-sm-3 col-xs-3 membercardlogo">
                  <div id="PEmobilelogo"></div>
                </div>
              </div>
            </div>
            <div class="membercardbody">
              <div class="row">
                <div class="col-md-12">
                  <div class="row membername">
                    <div class="col-md-12">{{ membershipdata.tblPersonName }}</div>
                  </div>
                  <div class="row memberlabel" v-for="(activity, index) in activitydata" :key="index">
                    <div class="col-md-12">
                      <label>{{ activity.labelName }}</label>
                    </div>
                    <div class="col-md-12 form-group">{{ activity.labelValue }}</div>
                  </div>

                  <div
                    class="row memberqrcode margin15bottom"
                    v-if="
                      membershipdata.qrCodeURL !== null &&
                      membershipdata.qrCodeURL !== '' &&
                      membershipdata.qrCodeURL !== undefined
                    "
                  >
                    <div class="col-md-12">
                      <a target="_blank" v-bind:href="membershipdata.qrCodeURL">
                        <qriously :value="membershipdata.qrCodeURL" :size="100" />
                      </a>
                    </div>
                  </div>
                  <div
                    class="row memberqrcode"
                    v-if="
                      membershipdata.qrCodeURL !== null &&
                      membershipdata.qrCodeURL !== '' &&
                      membershipdata.qrCodeURL !== undefined
                    "
                  >
                    <div class="col-md-12">
                      <span v-html="membershipdata.qrText"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="membercardfooter">
              <div class="row">
                <div class="col-md-12">
                  <span class="footertext" v-html="membershipdata.footerText"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Vue from 'vue'
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)
export default {
  mounted: async function () {
    await this.getmembercarddetails()
    this.stopLoading()
  },
  computed: {
    ...mapGetters('Spe032MemberCard', ['membershipdata', 'activitydata']),
    txtcreateDate() {
      return new Date(this.membershipdata.createDate).toLocaleDateString()
    },
  },
  methods: {
    ...mapActions('Spe032MemberCard', ['getmembercarddetails']),
  },
}
</script>
<style scoped>
.membercardheader {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 5px 10px 5px 10px;
}
.headertext {
  font-size: calc(100% + 2px);
  text-transform: uppercase;
}
.membercardfieldset {
  border: 1px solid #ccc;
  border-radius: 4px;
  max-width: 350px;
}

.membercardlogo #PEmobilelogo {
  margin-left: -10px;
  width: 75px;
  height: 75px;
  background-position: 50% 50%;
  border-radius: 50%;
  background-size: 55px auto;
  background-repeat: no-repeat;
  background-color: #fff;
  float: right;
}
.membercardbody {
  padding: 10px;
  background-color: #eee;
}
.membername {
  font-size: calc(100% + 2px);
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 20px;
}
.memberqrcode {
  text-align: center;
}
.membercardfooter {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 10px 10px 10px 10px;
  text-align: center;
}

@media (max-width: 991px) {
  .membercardfieldset {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
